import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "./testimonials.css";

import "swiper/css/navigation";
import { Box, Typography, Avatar, Button } from "@mui/material";

const reviews = [
    {
      id: 1,
      author_name: 'John Doe',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
    {
      id: 2,
      author_name: 'Jane Smith',
      text: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    {
      id: 3,
      author_name: 'Alice Johnson',
      text: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    },
    {
      id: 4,
      author_name: 'Bob Brown',
      text: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.',
    },
    {
      id: 5,
      author_name: 'Charlie Davis',
      text: 'Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.',
    },
    {
      id: 6,
      author_name: 'Eve White',
      text: 'Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
    },
  ];


const ReviewsCarousel = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedReviews, setExpandedReviews] = useState({});
    const [error, setError] = useState(null);
    const [startIndex, setStartIndex] = useState(0);
    const [reviewsPerPage, setReviewsPerPage] = useState(3); // Default to 3 reviews per page


    // Number of reviews to show at a time

    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth < 850) {
          setReviewsPerPage(1); // 1 review per page for small screens
        } else {
          setReviewsPerPage(3); // 3 reviews per page for larger screens
        }
      };
  
      // Initial check
      handleResize();
  
      // Add event listener for window resize
      window.addEventListener('resize', handleResize);
  
      // Cleanup event listener
      return () => window.removeEventListener('resize', handleResize);
    }, []);




    useEffect(() => {
      const fetchReviews = async () => {
        try {
          const response = await axios.get('https://wrangler-backend.laxmipalle72.workers.dev');

          console.log(response,"response from fetch");

        

          const data = await response.data.result.reviews;
          console.log("data",data)
  
         
            setReviews(data);
            const initialExpandedState = data.reduce((acc, review) => {
                acc[review.author_name] = false; // Set all reviews to collapsed by default
                return acc;
              }, {});
              setExpandedReviews(initialExpandedState);
            } catch (error) {
              setError(error.message); // Set error message
            } finally {
              setLoading(false); // Set loading to false
            }
        }
  
      fetchReviews();
    },[]);


    const StarRating = ({ rating }) => {
      const stars = [];
      for (let i = 1; i <= 5; i++) {
        stars.push(
          <span key={i} className={`star ${i <= rating ? 'filled' : ''}`}>
            {i <= rating ? '★' : '☆'}
          </span>
        );
      }
      return <div className="star-rating">{stars}</div>;
    };


    const toggleReadMore = (author_name) => {
        setExpandedReviews((prev) => ({
          ...prev,
          [author_name]: !prev[author_name], // Toggle the state for the specific review
        }));
      };


       // Handle moving to the previous set of reviews
  const handlePrev = () => {
    setStartIndex((prev) => Math.max(0, prev - reviewsPerPage));
  };

   // Handle moving to the next set of reviews
   const handleNext = () => {
    setStartIndex((prev) => Math.min(reviews.length - reviewsPerPage, prev + reviewsPerPage));
  };

  
      if (loading) {
        return <div>Loading reviews...</div>; // Display loading message
      }


  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

    // Get the subset of reviews to display
    const visibleReviews = reviews.slice(startIndex, startIndex + reviewsPerPage);

    return (

      <div className="review-title" >
        <h1 className="title">What our patients say</h1>
        <div className="carousel-container">
        
            <button className="carousel-button prev" onClick={handlePrev} disabled={startIndex === 0}>
        &#10094; {/* Left arrow */}
      </button>
          <div className="reviews-row">
            {visibleReviews.map((review) => (
              <div key={review.author_name} className="review-card">
                <h3>{review.author_name}</h3>
                <StarRating rating={review.rating} />
                <p className="review-date">{review.relative_time_description}</p>


                <p>
                  {expandedReviews[review.author_name]
                    ? review.text
                    : `${review.text.substring(0, 100)}...`}
                </p>
                <button onClick={() => toggleReadMore(review.author_name)}>
                  {expandedReviews[review.author_name] ? 'Read Less' : 'Read More'}
                </button>
              </div>
            ))}
          </div>

          <button
        className="carousel-button next"
        onClick={handleNext}
        disabled={startIndex >= reviews.length - reviewsPerPage}
      >
        &#10095; {/* Right arrow */}
      </button>
        </div>
        </div>
      );
    };

export default ReviewsCarousel;
